import { render, staticRenderFns } from "./AreaPrivacy.vue?vue&type=template&id=5462cad2&scoped=true&"
import script from "./AreaPrivacy.vue?vue&type=script&lang=js&"
export * from "./AreaPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./AreaPrivacy.vue?vue&type=style&index=0&id=5462cad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462cad2",
  null
  
)

export default component.exports